/**
 * iOSでもvhの表示が意図通り動作するようなCSSを生成する
 * 参照：https://zenn.dev/tak_dcxi/articles/2ac77656aa94c2cd40bf
 * @param vh
 */
const getViewportHeight = (vh: number): string =>
  `calc(var(--vh, 1vh) * ${vh});`;

export default getViewportHeight;
